var Component = require("!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./roleright.vue"),
  /* template */
  require("!!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-78611f44\"}!../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./roleright.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/sys/roleright.vue
// module id = 225
// module chunks = 1